// extracted by mini-css-extract-plugin
export default {"listContainer":"PopularSearches-listContainer","list":"PopularSearches-list"};